/* istanbul ignore file */
import React, { useEffect } from "react";
import Radar from "radar-sdk-js";
import "radar-sdk-js/dist/radar.css";
import "./styles.scss";
import { useTranslation } from "react-i18next";
import clsx from "clsx";

const API_KEY = process.env.REACT_APP_RADAR_CLIENT_API_KEY ?? "";

export default function AutocompleteAddress({
	errorMessage,
	placeholder,
	onChangeLocation,
	isFilled = false,
	showLabel = true,
	className,
	id = "autocomplete-address"
}) {
	const { t } = useTranslation();

	useEffect(() => {
		Radar.initialize(API_KEY);
		const autocomplete = Radar.ui.autocomplete({
			container: id,
			onSelection: (selection) => {
				const {
					formattedAddress,
					stateCode,
					city,
					postalCode,
					longitude: lng,
					latitude: lat
				} = selection;
				const location = {
					formattedAddress,
					stateCode,
					city,
					postalCode,
					location: {
						lng,
						lat
					}
				};
				onChangeLocation(location);
			},
			countryCode: "US",
			placeholder: placeholder ?? t("START_TYPING_TO_SELECT_YOUR_CITY"),
			width: "100%"
		});
		return () => {
			autocomplete.remove();
		};
	}, []);

	return (
		<div
			className={clsx(
				"autocomplete-container-address",
				{
					"error-container": errorMessage?.length
				},
				className
			)}
		>
			{showLabel ? <label>{t("CITY_OF_ACCIDENT")}:</label> : null}

			{isFilled ? (
				<span className="input-ok">
					<img src="/assets/checked.svg" />
				</span>
			) : null}

			<div id={id} />

			{errorMessage ? (
				<span className="autocomplete-error">{errorMessage}</span>
			) : null}
		</div>
	);
}
